import { useState } from 'react';
import { Link } from 'react-router-dom';

const LOGO_SRC =
  'https://cdn.prod.website-files.com/66be57f81bd23266cc3a7b3b/66f2a24fa2376b27b2a64ef3_63324187d2509f7567744a3c_logo.svg';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-[#f4eee6]">
      <div className="mx-auto flex max-w-content items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center">
          <img src={LOGO_SRC} alt="ISHI" className="h-7 w-auto" />
        </Link>

        {/* Hamburger button – visible on mobile only */}
        <button
          type="button"
          className="inline-flex items-center justify-center rounded-md p-2 text-heading/70 hover:text-heading md:hidden"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {menuOpen ? (
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>

        {/* Desktop links – hidden on mobile */}
        <div className="hidden items-center gap-8 md:flex">
          <Link
            to="/"
            className="font-body text-sm font-medium text-heading/70 transition-colors hover:text-heading"
          >
            Open Positions
          </Link>
          <a
            href="https://ishi.health"
            target="_blank"
            rel="noopener noreferrer"
            className="font-body text-sm font-medium text-heading/70 transition-colors hover:text-heading"
          >
            About ISHI
          </a>
          <a
            href="https://ishi.health"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full border border-brand-purple px-5 py-2 font-heading text-sm font-medium text-brand-purple transition-all hover:bg-brand-purple hover:text-white"
          >
            Contact Us
          </a>
        </div>
      </div>

      {/* Mobile menu dropdown */}
      {menuOpen && (
        <div className="border-t border-heading/10 px-6 pb-4 pt-2 md:hidden">
          <div className="flex flex-col gap-3">
            <Link
              to="/"
              onClick={() => setMenuOpen(false)}
              className="font-body text-sm font-medium text-heading/70 transition-colors hover:text-heading"
            >
              Open Positions
            </Link>
            <a
              href="https://ishi.health"
              target="_blank"
              rel="noopener noreferrer"
              className="font-body text-sm font-medium text-heading/70 transition-colors hover:text-heading"
            >
              About ISHI
            </a>
            <a
              href="https://ishi.health"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-1 inline-block w-fit rounded-full border border-brand-purple px-5 py-2 font-heading text-sm font-medium text-brand-purple transition-all hover:bg-brand-purple hover:text-white"
            >
              Contact Us
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
